var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.5,146c39-.2,70.5-32,70.4-71-.2-39-32-70.5-71-70.3C35.8,4.8,4.3,36.6,4.5,75.6s32,70.5,71,70.4ZM74,17.2c32.1-.1,58.2,25.7,58.3,57.8.1,32.1-25.7,58.2-57.8,58.3s-58.2-25.7-58.3-57.8c-.1-32.1,25.7-58.2,57.8-58.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.7,74.3v-.3c0-4.3,3.5-7.9,7.8-7.9l46.3-.2-7.5-6.7c-3.3-2.9-3.6-8-.6-11.3,1.6-1.8,3.8-2.7,6-2.7s3.8.7,5.4,2c3.6,3.3,7.3,6.5,10.9,9.8,3.7,3.3,7.3,6.5,11,9.8.3.2.8.6,1.2,1,.3.3.8.9,1.3,1.7.7,1.2,1.1,2.6,1.1,4,0,2.1-.8,4.1-2.3,5.7l-22.6,22.8c-3.1,3.1-8.2,3.2-11.3,0s-2.4-3.6-2.4-5.7.8-4.1,2.3-5.7l8.7-8.7-47.3.2c-4.3,0-7.9-3.5-7.9-7.8Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/right_arrow_icon.dccbb6349579e290f48ad77b0c5b913e.svg";
export { ForwardRef as ReactComponent };